import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons/faCircleNotch";

import Button from "./Button";

const IconWrapper = styled.span`
    display: inline-block;
    margin-right: ${({ indent }) => (indent ? "0.5rem" : "0")};
    transition: all 500ms;
`;
const SubmitButton = ({
    icon,
    submitting,
    submittingIcon,
    children,
    label,
    ...props
}) => {
    return (
        <Button disabled={submitting} {...props} type="submit">
            <IconWrapper indent={submitting || icon}>
                {submitting ? submittingIcon : icon ? icon : ""}
            </IconWrapper>
            {label ? label : children}
        </Button>
    );
};

SubmitButton.displayName = "SubmitButton";

SubmitButton.propTypes = {
    submitting: PropTypes.bool,
    /** The Icon to use whilst NOT submitting - probably a Font Awesome icon like   <FontAwesomeIcon icon={faCircleNotch} spin />
     * If none is supplied no icon will display
     */
    icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    /** The Icon to use whilst submitting - probably a Font Awesome icon like  <FontAwesomeIcon icon={faCircleNotch} spin /> */
    submittingIcon: PropTypes.object
};

SubmitButton.defaultProps = {
    submitting: false,
    icon: false,
    submittingIcon: <FontAwesomeIcon icon={faCircleNotch} spin />
};

export default SubmitButton;
